import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Button,
  Modal,
  Tooltip,
  FormGroup,
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { format } from "date-fns";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import classnames from "classnames";
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import AssignedUsers from "src/components/Common/AssignedUsers";
import { FormikErrors, useFormik } from "formik";
import "../../../assets/scss/custom/components/picker.scss";
import { addProject } from "src/slices/thunks";
import { AppDispatch } from "src";
import Select from 'react-select';

const ProjectCreate = () => {
  document.title = "Adicionar Actividade - Khozi";
  const [selectedFiles, setselectedFiles] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [tooltipOpen2, setTooltipOpen2] = useState(false);
  const toggle2 = () => setTooltipOpen2(!tooltipOpen2);
  const [tooltipOpen3, setTooltipOpen3] = useState(false);
  const toggle3 = () => setTooltipOpen3(!tooltipOpen3);
  const [tooltipOpen4, setTooltipOpen4] = useState(false);
  const toggle4 = () => setTooltipOpen4(!tooltipOpen4);
  const [modal_standard, setmodal_standard] = useState(false);
  const [activeTab, setactiveTab] = useState(1);
  const units = useSelector((state: any) => state.units.units);
  const users = useSelector((state: any) => state.users.users);
  //const financing = useSelector((state: any) => state.financing.financing);

  const financing = useSelector((state: any) => state.financing.financing.map(
      (fin:any) => ({
        value: fin.id,
        label: fin.nome,
      })
    )
  );

  const responsibleUsers = useSelector((state: any) => state.users.users.map(
    (user:any) => ({
      value: user.profile__id,
      label: `${user.first_name} ${user.last_name}`,
    })
  )
);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [objectives, setObjectives] = useState([
    { id: 1, quantity: "", unit: "" },
  ]);

  const addObjective = () => {
    setObjectives([
      ...objectives,
      { id: objectives.length + 1, quantity: "", unit: "" },
    ]);
  };
  const [step1Values, setStep1Values] = useState<Step1Values>({
    nome: "",
    projectDesc: "",
    provenienciaFundo: "",
    prazoPrevisto: "",
    dataInicio: "",
    valorPrevisto: 0,
  });
  const [step2Values, setStep2Values] = useState<Step2Values>({
    objectives: objectives.map(obj => ({
      quantity: obj.quantity,
      unit: obj.unit,
    })),
  });
  const [step3Values, setStep3Values] = useState<Step3Values>({
    responsibles: "",
    team: "",
  });
  function handleAcceptedFiles(files: any) {
    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
  }
  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  function toggleTab(tab: any) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
      }
    }
  }
  function tog_standard() {
    setmodal_standard(!modal_standard);
  }

  const groupedUsers = users.reduce((acc: any, user: any) => {
    const firstLetter = user.first_name ? user.first_name[0].toUpperCase() : "";
    if (firstLetter) {
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(user);
    }
    return acc;
  }, {});

  const [searchTerm, setSearchTerm] = useState("");

  // Function to handle search input change
  function handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }

  // Filtered users based on search term
  const filteredUsers = Object.keys(groupedUsers).reduce(
    (acc: any, letter: string) => {
      const users = groupedUsers[letter].filter((user: any) =>
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (users.length > 0) {
        acc[letter] = users;
      }
      return acc;
    },
    {}
  );

  const [assignedUsers, setAssignedUsers] = useState<number[]>([]);
  const [selectedUserIds, setSelectedUserIds] = useState<Set<number>>(
    new Set()
  );

  const handleRadioChange = (userId: any) => {
    setSelectedUserIds(new Set([userId]));
    setAssignedUsers([userId]);
    step3.setFieldValue("responsibles", userId);
  };

  const handleSave = () => {
    setAssignedUsers(Array.from(selectedUserIds));
    setmodal_standard(false);
  };

  const handleObjectiveChange = (index: number, field: "quantity" | "unit", value: string) => {
    step2.setFieldValue(`objectives[${index}].${field}`, value);
    const newObjectives = [...objectives];
    newObjectives[index][field] = value;
    setObjectives(newObjectives);
  };

  const step1 = useFormik({
    initialValues: {
      nome: "",
      projectDesc: "",
      provenienciaFundo: "",
      prazoPrevisto: "",
      dataInicio: "",
      valorPrevisto: "",
    },
    validationSchema: Yup.object({
      nome: Yup.string().required("Nome da Actividade é obrigatório"),
      projectDesc: Yup.string().required("Descrição da Actividade é obrigatória"),
      //provenienciaFundo: Yup.string().required("Proveniência do Fundo é obrigatória"),
      prazoPrevisto: Yup.date().required("Data de término  é obrigatória"),
      valorPrevisto: Yup.number().required("Valor Previsto é obrigatório"),
      dataInicio: Yup.date().required("Data de início é obrigatória"),
    }),
    onSubmit: values => {
      setStep1Values({
        ...values,
        valorPrevisto: parseFloat(values.valorPrevisto),
      });
      toggleTab(activeTab + 1);
    },
  });

  const step2 = useFormik({
    initialValues: {
      objectives: objectives.map(obj => ({
        quantity: obj.quantity,
        unit: obj.unit,
      })),
    },
    validationSchema: Yup.object({
      objectives: Yup.array().of(
        Yup.object().shape({
          quantity: Yup.number()
            .required("Quantidade é obrigatória")
            .positive("Quantidade deve ser positiva"),
          unit: Yup.string().required("Unidade é obrigatória"),
        })
      ),
    }),
    onSubmit: values => {
      setStep2Values(values);
      toggleTab(activeTab + 1);
    },
  });

  const step3 = useFormik({
    initialValues: {
      responsibles: "",
      team: "",
    },
    validationSchema: Yup.object({
      //responsibles: Yup.string().required("Responsável é obrigatório"),
      team: Yup.string().required("Equipa é obrigatória"),
    }),
    onSubmit: (values, {setSubmitting}) => {
      setSubmitting(true);
      dispatch(
        addProject({
          ...step1Values,
          ...step2Values,
          ...values,
        })
      ).then((response: any) => {
        setSubmitting(false);
        navigate(`/projects/${response.payload.id}`);
      });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Actividades" breadcrumbItem="Criar Actividade" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div>
                    <ul className="wizard-nav mb-5">
                      <li className="wizard-list-item">
                        <div className={classnames({ active: activeTab === 1 }, "list-item")} id={"Tooltip-1"}>
                          <div className="step-icon">
                            <i className="uil uil-clipboard-notes"></i>
                          </div>
                        </div>
                        <Tooltip placement="top" isOpen={tooltipOpen} target={"Tooltip-1"} toggle={toggle}>
                          Informação básica
                        </Tooltip>
                      </li>
                      <li className="wizard-list-item">
                        <div className={classnames({ active: activeTab === 2 },"list-item")} id={"Tooltip-2"}>
                          <div className="step-icon">
                            <i className="uil uil-bullseye"></i>
                          </div>
                        </div>
                        <Tooltip placement="top" isOpen={tooltipOpen2} target={"Tooltip-2"} toggle={toggle2}>
                          Quantificação
                        </Tooltip>
                      </li>
                      <li className="wizard-list-item">
                        <div className={classnames({ active: activeTab === 3 },"list-item")} id={"Tooltip-3"}>
                          <div className="step-icon">
                            <i className="uil uil-user-circle"></i>
                          </div>
                        </div>
                        <Tooltip placement="top" isOpen={tooltipOpen3} target={"Tooltip-3"} toggle={toggle3}>
                          Responsável
                        </Tooltip>
                      </li>
                    </ul>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={1}>
                        <div className="text-center mb-4">
                          <h5>Informação da Actividade</h5>
                          <p className="card-title-desc">Preencha todas as informações abaixo</p>
                        </div>
                        <Form>
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom01">Nome da Actividade</Label>
                            <Input
                              placeholder="Insira o nome da actividade"
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              {...step1.getFieldProps("nome")}
                              invalid={step1.touched.nome && step1.errors.nome ? true : false}
                            />
                          </FormGroup>
                          <FormGroup className="mb-3">
                            <Label htmlFor="projectDesc" className="form-label">
                              Descrição da Actividade
                            </Label>
                            <Input
                              type="textarea"
                              className="form-control"
                              id="projectDesc"
                              rows={2}
                              placeholder="Insira a descrição da actividade"
                              {...step1.getFieldProps("projectDesc")}
                              invalid={step1.touched.projectDesc && step1.errors.projectDesc ? true : false}
                            ></Input>
                          </FormGroup>
                          <FormGroup className="mb-3">
                            <Label htmlFor="provenienciaFundo" className="form-label">
                              Proveniência do Fundo
                            </Label>
                            
                            {/*<Input
                              type="select"
                              className="form-control"
                              {...step1.getFieldProps("provenienciaFundo")}
                            >
                              <option value="">
                                Seleccione uma proveniência
                              </option>
                              {financing ? financing.map((financing: any) => (
                                    <option value={financing.id} key={financing.id}>
                                      {financing.nome}
                                    </option>
                                  ))
                                : null}
                            </Input>*/}
                            
                            <Select isMulti className="form-control" classNamePrefix="select" 
                              options={financing} id="provenienciaFundo" 
                              onChange={(selectedOption:any, _:any) => step1.setFieldValue('provenienciaFundo', selectedOption)
                              }
                              />
                          </FormGroup>
                          <Row>
                            <Col md={6}>
                              <FormGroup className="mb-3">
                                <Label className="form-label">Data de Início</Label>
                                <Flatpickr
                                  placeholder="Insira a data de início"
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                  value={step1.values.dataInicio}
                                  onChange={(date: Date[]) => {
                                    const formattedDate = date.length
                                      ? format(date[0], "yyyy-MM-dd")
                                      : "";
                                    step1.setFieldValue(
                                      "dataInicio",
                                      formattedDate
                                    );
                                  }}
                                  onBlur={step1.handleBlur}
                                  className={`form-control ${
                                    step1.touched.dataInicio &&
                                    step1.errors.dataInicio
                                      ? "invalid-field"
                                      : ""
                                  }`}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup className="mb-3">
                                <Label className="form-label">
                                  Data de Término
                                </Label>
                                <Flatpickr
                                  placeholder="Insira a data de término"
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                  value={step1.values.prazoPrevisto}
                                  onChange={(date: Date[]) => {
                                    const formattedDate = date.length
                                      ? format(date[0], "yyyy-MM-dd")
                                      : "";
                                    step1.setFieldValue("prazoPrevisto",formattedDate);
                                  }}
                                  onBlur={step1.handleBlur}
                                  invalid={step1.touched.prazoPrevisto && step1.errors.prazoPrevisto ? true : false}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <FormGroup className="mb-3">
                            <Label className="form-label">Valor Previsto</Label>
                            <Input
                              className="form-control"
                              id="valorPrevisto"
                              type="number"
                              placeholder="Insira o valor previsto para a actividade (MZN)"
                              {...step1.getFieldProps("valorPrevisto")}
                              invalid={step1.touched.valorPrevisto && step1.errors.valorPrevisto ? true : false}
                            ></Input>
                          </FormGroup>
                        </Form>
                      </TabPane>
                      <TabPane tabId={2}>
                        <div className="text-center mb-4">
                          <h5>Quantificação</h5>                          
                        </div>
                        <Form>
                          {objectives.map((objective, index) => (
                            <div key={index}>
                              <Row className="mb-3">
                                <Col md={9}>
                                  <Label for={`quantidadePrevista-${index}`}>
                                    Quantidade Prevista
                                  </Label>
                                  <Input
                                    type="number"
                                    id={`quantidadePrevista-${index}`}
                                    className="form-control"
                                    placeholder="Insira a quantidade prevista"
                                    value={objective.quantity}
                                    onChange={e =>
                                      handleObjectiveChange(index,"quantity",e.target.value)
                                    }
                                    invalid={
                                      step2.touched.objectives?.[index] ?.quantity &&
                                      typeof step2.errors.objectives?.[index] === "object" &&
                                      (
                                        step2.errors.objectives[index] as FormikErrors<{
                                          quantity: string;
                                          unit: string;
                                        }>
                                      ).quantity ? true : false
                                    }
                                  />
                                </Col>
                                <Col md={3}>
                                  <Label for={`unidade-${index}`}>Unidade</Label>
                                  <Input
                                    type="select"
                                    id={`unidade-${index}`}
                                    className="form-control"
                                    value={objective.unit}
                                    onChange={e =>
                                      handleObjectiveChange(index,"unit",e.target.value)
                                    }
                                    invalid={
                                      step2.touched.objectives?.[index]?.unit &&
                                      typeof step2.errors.objectives?.[index] === "object" &&
                                      (
                                        step2.errors.objectives[index] as FormikErrors<{
                                          quantity: string;
                                          unit: string;
                                        }>
                                      ).unit ? true : false
                                    }
                                  >
                                    <option value="">Seleccione a unidade</option>
                                    <option value="ha">ha</option>
                                    <option value="Km">Km</option>
                                    <option value="Lote">Lote</option>
                                    <option value="m">m</option>
                                    <option value="m2">m2</option>
                                    <option value="m3">m3</option>
                                    <option value="mL">mL</option>
                                    <option value="Percentagem">Percentagem</option>
                                    <option value="Pessoas">Pessoas</option>
                                    <option value="UN">UN</option>
                                    <option value="VG">VG</option>
                                  </Input>
                                </Col>
                              </Row>
                            </div>
                          ))}
                          {/*<div className="d-flex justify-content-end">
                            <Button
                              type="button"
                              color="primary"
                              onClick={addObjective}
                              outline
                            >
                              Adicionar Objectivo
                            </Button>
                          </div>*/}
                        </Form>
                      </TabPane>
                      <TabPane tabId={3}>
                        <div className="text-center mb-4">
                          <h5>Responsáveis</h5>
                          <p className="card-title-desc">Seleccione os Responsáveis Pela Actividade</p>
                        </div>
                        <Form>
                          <div>
                            <div className="mb-3">
                              <Label>Equipa</Label>
                              <Input
                                type="select"
                                name="team"
                                className="form-select shadow-none"
                                value={step3.values.team}
                                onChange={e => {
                                  step3.setFieldValue("team", e.target.value);
                                }}
                                invalid={step3.touched.team && step3.errors.team ? true : false}
                              >
                                <option value="">Seleccione a equipa</option>
                                {units.map((unit: any) => (
                                  <option value={unit.id} key={unit.id}>
                                    {unit.name}
                                  </option>
                                ))}
                              </Input>
                            </div>                            
                            <div className="mb-4">
                              <Label>Responsáveis</Label>
                              <Select isMulti className="form-control" classNamePrefix="select" 
                                options={responsibleUsers} id="responsibles" 
                                onChange={(selectedOption:any, _:any) => step3.setFieldValue('responsibles', selectedOption)
                              }/>                              
                            </div>
                          </div>
                        </Form>
                      </TabPane>
                    </TabContent>

                    <div className="d-flex align-items-start gap-3 mt-4">
                      {activeTab !== 1 && (
                        <Button type="button" color="primary" className="w-sm" id="prevBtn"
                          onClick={() => {
                            toggleTab(activeTab - 1);
                          }}
                        >
                          Anterior
                        </Button>
                      )}

                      {activeTab !== 3 && (
                        <Button
                          type="button"
                          color="primary"
                          className="w-sm ms-auto"
                          id="nextBtn"
                          onClick={() => {
                            if (activeTab === 1) {
                              step1.handleSubmit();
                            } else if (activeTab === 2) {
                              step2.handleSubmit();
                            }
                          }}
                        >
                          Próximo
                        </Button>
                      )}

                      {activeTab === 3 && (
                        <Button
                          type="button"
                          color="primary"
                          className="btn btn-primary w-sm ms-auto"
                          id="nextBtn"
                          onClick={() => {
                            step3.handleSubmit();
                          }}
                        >
                          {step3.isSubmitting ? 'Salvando a Actividade...' : 'Criar Actividade'}
                        </Button>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectCreate;
